export const footer = () => {

  const footerHeading = '.js-footer-heading';
  const toggleFooterSection = '.js-toggle-footer-section';

  const toggleNewsletter = '.js-toggle-newsletter';
  const newsletterSection = '.js-newsletter';

  const inputEmail = '.js-input-email';
  const inputSubscribe = '.js-input-subscribe';

  let footerHeadingOpen = false;
  let inputTriggered = false;

  const init = () => {
    bind();
  };

  const bind = () => {

    var lastScrollTop = 0;

    window.addEventListener("scroll", function(){
       var st = window.pageYOffset || document.documentElement.scrollTop;
       if (st > lastScrollTop){
          // downscroll code
       } else {
          if(footerHeadingOpen == true) {
            closeFooterHeading();
          }
       }
       lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);


    function openFooterHeading() {
      $(footerHeading).attr('data-state','open');
      footerHeadingOpen = true;
    }

    function closeFooterHeading() {
      $('.js-footer-heading-item').attr('data-state','closed');
      $(footerHeading).attr('data-state','closed');
      footerHeadingOpen = false;
    }

    $(toggleFooterSection).on('click', function(e) {
      e.preventDefault();
      const element = $(this).data('href');
      $(this).toggleClass('is-active');

      if(footerHeadingOpen == false) {
        openFooterHeading();
      }

      if($('#'+element).attr('data-state') == 'open') {
        $('#'+element).attr('data-state','closed');
        closeFooterHeading();
        // $('.js-footer-heading-item').attr('data-state','closed');
      } else {
        $('.js-footer-heading-item').attr('data-state','closed');
        $('#'+element).attr('data-state','open');
        // $('.js-footer-heading-item').attr('data-state','open');
      }


      // $('#'+element).attr('data-state', $('#'+element).attr('data-state') =='closed' ? 'open' : 'closed');

    });

    $(toggleNewsletter).on('click', function(e) {
      e.preventDefault();
      $(newsletterSection).attr('data-state', $(newsletterSection).attr('data-state') =='closed' ? 'open' : 'closed');
      if($(newsletterSection).attr('data-state') == 'open') {
        $(inputEmail).focus();
      }
    });

    $(inputEmail).on('click', function(e) {
      if(inputTriggered !== true) {
        $(this).val('');
        inputTriggered = true;
      }
    });

    $(inputEmail).keyup(function(){
  		validateMailInput(inputEmail,inputSubscribe);
  	});

  };

  const validateMailInput = (input, submitButton) => {

    var submit = submitButton;
    var data = $(input).val();
    var regx = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if ( data.match(regx) ){
      $(submitButton).prop('disabled', false);
    }
    else {
      $(submitButton).prop('disabled', true);
    }

  };

  init();

};
